import {
  alpha,
  Box,
  Divider,
  Grid,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import { ScoreLayout } from "~/pages/space/security/components/Check/ScoreBlock/ScoreLayout";

type CompletionProps = {
  progress: number;
  exceptionCount?: number;
  outOfScopeCount?: number;
};

export function CompletionV2({
  progress,
  exceptionCount,
  outOfScopeCount,
}: CompletionProps) {
  const theme = useTheme();

  const getColor = () => {
    if (progress >= 91) return theme.palette.none.main;
    if (progress >= 71) return theme.palette.low.main;
    if (progress >= 41) return theme.palette.medium.main;
    if (progress >= 1) return theme.palette.high.main;
    return theme.palette.critical.main;
  };

  const color = getColor();

  const hasSecondaryMetrics =
    exceptionCount !== undefined || outOfScopeCount !== undefined;

  return (
    <Grid
      id="score-box"
      container
      component={Paper}
      sx={{
        display: "block",
        p: 5,
        width: {
          xs: "100%",
          sm: 360,
          md: "100%",
        },
        backgroundColor: alpha(color, 0.05),
      }}
      size={12}
    >
      <Grid
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pb: 3,
          textAlign: "center",
        }}
        size={12}
      >
        <Grid size="grow">
          <Box mb={3}>
            <Typography
              component="span"
              sx={{
                color,
                fontWeight: 700,
                fontSize: "48px",
                lineHeight: 1,
              }}
            >
              {progress}
            </Typography>
            <Typography
              component="span"
              sx={{
                color,
                fontWeight: 700,
                fontSize: "24px",
              }}
            >
              %
            </Typography>
            <Typography
              sx={{
                fontWeight: 700,
                textTransform: "uppercase",
                mt: 1,
                fontSize: "0.75rem",
                letterSpacing: "0.05em",
              }}
            >
              Completion
            </Typography>
          </Box>
          <Divider sx={{ backgroundColor: alpha(color, 0.1) }} />
        </Grid>
      </Grid>
      {hasSecondaryMetrics && (
        <Grid
          container
          rowGap={2}
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
          size="grow"
        >
          {exceptionCount !== undefined && (
            <ScoreLayout
              type="exceptions"
              title="Exceptions"
              amount={
                <Typography sx={{ fontWeight: 700 }}>
                  {exceptionCount}
                </Typography>
              }
            />
          )}
          {outOfScopeCount !== undefined && (
            <ScoreLayout
              type="out-of-scope"
              title="Out of scope"
              amount={
                <Typography sx={{ fontWeight: 700 }}>
                  {outOfScopeCount}
                </Typography>
              }
            />
          )}
        </Grid>
      )}
    </Grid>
  );
}
